'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { MAX_SELECTED_EXAMS } from './_hooks/use-laboratory-exam-selection.hook';

import { Button } from '@/components/ui/button/button.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { currencyFormatter } from '@/utils/formatters/currency';

interface LaboratoryExamsFooterProps {
  count: number;
  total: number;
  isFull?: boolean;
  onSeeSchedules(): void;
}

export function LaboratoryExamsFooter({
  count,
  total,
  isFull = false,
  onSeeSchedules,
}: LaboratoryExamsFooterProps) {
  if (count === 0) {
    return null;
  }

  return (
    <div
      data-testid={DataTestIdEnum.BRANCH_LABORATORY_EXAMS_FOOTER}
      className="bg-white p-3 shadow-modal"
    >
      <div className="flex w-full items-center gap-2 rounded-xxl border border-gray-300 bg-gray-100 py-2 pl-4 pr-2">
        <div className="flex min-w-0 flex-1 flex-col justify-center">
          <Typography
            variant={TypographyVariant.MEDIUM_BODY_TEXT}
            as="span"
            className="py-1.5 font-semibold leading-5 text-green-500"
          >
            {count === 1 ? '1 selecionado' : `${count} selecionados`}
          </Typography>

          {isFull && (
            <Typography
              variant={TypographyVariant.MEDIUM_BODY_TEXT}
              as="span"
              className="text-gray-500"
              data-testid={DataTestIdEnum.BRANCH_LABORATORY_EXAMS_FOOTER_LIMIT}
            >
              {`Máximo de ${MAX_SELECTED_EXAMS} exames por agendamento`}
            </Typography>
          )}

          <Typography
            variant={TypographyVariant.BODY_TEXT}
            as="span"
            className="text-gray-800"
            data-testid={DataTestIdEnum.BRANCH_LABORATORY_EXAMS_FOOTER_TOTAL}
          >
            Total
            {' '}
            <strong className="font-bold">{currencyFormatter(total)}</strong>
          </Typography>
        </div>

        <Button
          data-testid={DataTestIdEnum.BRANCH_LABORATORY_SEE_SCHEDULES_BUTTON}
          className="w-fit shrink-0"
          onClick={onSeeSchedules}
        >
          Ver horários
        </Button>
      </div>
    </div>
  );
}
